import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const SimpleEmptyStateContainer = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(0.5),
}));

export const SimpleEmptyStateTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  marginBottom: theme.spacing(0.5),
}));

export const SimpleEmptyStateDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
}));
